// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appName: 'HappybeautyMarketplaceSG',
  webUrl: 'https://happybeauty.com.sg/',
  apiUrl: 'https://api.happybeauty.com.sg/api/v1/',
  discountRouding: 1,
  facebookUrl: 'https://www.facebook.com/happybeautysingapore',
  instagramUrl: 'https://www.instagram.com/happybeautysg/',
  youtubeUrl: 'https://www.youtube.com/@happybeauty1341',
  merchantUrl: 'https://merchant.happybeauty.com.sg',
  googleClientId:
    '509755179340-mb1ski4mtd1qifnlvidpfn4i2fg2d956.apps.googleusercontent.com',
  facebookClientId: '4445851862118798',
  gRecaptchaSiteKey: '6LegHlUjAAAAADtff0db4JGtzFHT6JfQUkcbYgSl',
  locale_string: 'SGD',
  default_currency_code: 'sg',
  sentryDSN: undefined,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
